import { defaultSkipElementChildren } from "../dsCoverage/utils/defaultSkipElementChildren.js";
import { drawDOMIdentityHeatmap } from "../dsCoverage/utils/drawDOMIdentityHeatmap.js";
import { drawDOMIdentitySvg } from "../dsCoverage/utils/drawDOMIdentitySvg.js";
import { componentIdentityMap, coverageRootId } from "./constants.js";
function defaultGetRoot() {
  const body = globalThis.document.body;
  return body.querySelector('[data-id="tidal-stories-content"]') ?? body;
}
function skipElementChildren(element, identity) {
  if (element.id === coverageRootId) {
    return true;
  }
  switch (identity) {
    // skip leaf node children
    case componentIdentityMap.muiInput:
    case componentIdentityMap.muiDataDisplay:
    case componentIdentityMap.muiFeedback:
    case componentIdentityMap.tidalInput:
    case componentIdentityMap.tidalDataDisplay:
    case componentIdentityMap.tidalFeedback:
      return true;
  }
  return defaultSkipElementChildren(element);
}
function identityToStrokeColor(identity) {
  switch (identity) {
    case componentIdentityMap.tidalDataDisplay:
    case componentIdentityMap.tidalFeedback:
    case componentIdentityMap.tidalInput:
    case componentIdentityMap.tidalNavigation:
    case componentIdentityMap.tidalSurface:
    case componentIdentityMap.tidalUtil:
    case componentIdentityMap.tidalLayout:
    case componentIdentityMap.tidalUnknown:
      return "var(--tidal-coverage-tidal, #47B882)";
    case componentIdentityMap.muiDataDisplay:
    case componentIdentityMap.muiFeedback:
    case componentIdentityMap.muiInput:
    case componentIdentityMap.muiLayout:
    case componentIdentityMap.muiNavigation:
    case componentIdentityMap.muiSurface:
    case componentIdentityMap.muiUtil:
    case componentIdentityMap.muiUnknown:
      return "var(--tidal-coverage-mui, #3E98FF)";
    default:
      return "var(--tidal-coverage-other, #F9BA1B)";
  }
}
function identityToString(identity) {
  switch (identity) {
    case componentIdentityMap.tidalDataDisplay:
      return "Tidal DataDisplay";
    case componentIdentityMap.tidalFeedback:
      return "Tidal Feedback";
    case componentIdentityMap.tidalInput:
      return "Tidal Input";
    case componentIdentityMap.tidalLayout:
      return "Tidal Layout";
    case componentIdentityMap.tidalNavigation:
      return "Tidal Navigation";
    case componentIdentityMap.tidalSurface:
      return "Tidal Surface";
    case componentIdentityMap.tidalUtil:
      return "Tidal Util";
    case componentIdentityMap.tidalUnknown:
      return "Tidal Unknown";
    case componentIdentityMap.muiDataDisplay:
      return "MUI DataDisplay";
    case componentIdentityMap.muiFeedback:
      return "MUI Feedback";
    case componentIdentityMap.muiInput:
      return "MUI Input";
    case componentIdentityMap.muiLayout:
      return "MUI Layout";
    case componentIdentityMap.muiNavigation:
      return "MUI Navigation";
    case componentIdentityMap.muiSurface:
      return "MUI Surface";
    case componentIdentityMap.muiUtil:
      return "MUI Util";
    case componentIdentityMap.muiUnknown:
      return "MUI Unknown";
    default:
      return "Non DS";
  }
}
function identityToWeight(identity) {
  switch (identity) {
    // mui "leaf" nodes
    case componentIdentityMap.muiInput:
    case componentIdentityMap.muiDataDisplay:
    case componentIdentityMap.muiFeedback:
      return 1;
    // mui "layout" nodes
    case componentIdentityMap.muiNavigation:
    case componentIdentityMap.muiSurface:
    case componentIdentityMap.muiUtil:
      return 1;
    case componentIdentityMap.muiUnknown:
      return 1;
    // tidal "leaf" nodes
    case componentIdentityMap.tidalInput:
    case componentIdentityMap.tidalDataDisplay:
    case componentIdentityMap.tidalFeedback:
      return 1;
    // tidal "layout" nodes
    case componentIdentityMap.tidalNavigation:
    case componentIdentityMap.tidalSurface:
    case componentIdentityMap.tidalUtil:
      return 1;
    case componentIdentityMap.tidalUnknown:
      return 1;
    case componentIdentityMap.nonDs:
    default:
      return 0;
  }
}
function drawTidalCoverageSVG(identities, renderer) {
  return drawDOMIdentitySvg({
    identities,
    identityToStroke: identityToStrokeColor,
    renderer
  });
}
function drawTidalCoverageHeatmap(identities, renderer) {
  return drawDOMIdentityHeatmap({
    identities,
    identityToStroke: identityToStrokeColor,
    renderer
  });
}
function formatCoverageCounts(coverageCounts) {
  const { total, ...counts } = coverageCounts;
  const result = Object.entries(counts).reduce((acc, [key, pixels]) => {
    const identity = Number(key);
    const identityLabel = identityToString(identity);
    const percentage = pixels / total * 100;
    acc[identityLabel] = {
      percentage,
      pixels
    };
    return acc;
  }, {});
  result.total = {
    percentage: 100,
    pixels: total
  };
  return result;
}
export {
  defaultGetRoot,
  drawTidalCoverageHeatmap,
  drawTidalCoverageSVG,
  formatCoverageCounts,
  identityToString,
  identityToStrokeColor,
  identityToWeight,
  skipElementChildren
};
//# sourceMappingURL=utils.js.map
